var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-filter",
    { ref: "filter-component" },
    [
      _c(
        "filter-fieldset",
        {
          attrs: { title: _vm.t("app-status") },
          model: {
            value: _vm.properties.open[0],
            callback: function ($$v) {
              _vm.$set(_vm.properties.open, 0, $$v)
            },
            expression: "properties.open[0]",
          },
        },
        [
          _c("app-select", {
            attrs: {
              label: _vm.t("app-status"),
              options: _vm.options.standing,
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.standing],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.standing,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.standing]",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filter-fieldset",
        {
          attrs: { title: _vm.t("app-organization-general-information") },
          model: {
            value: _vm.properties.open[1],
            callback: function ($$v) {
              _vm.$set(_vm.properties.open, 1, $$v)
            },
            expression: "properties.open[1]",
          },
        },
        [
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-organization-name") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.displayTitle],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.displayTitle,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.displayTitle]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: {
              type: "text",
              label: _vm.t("app-organization-legal-name"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.legalName],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.legalName,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.legalName]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: {
              type: "text",
              label: _vm.t("app-organization-description"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.description],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.description,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.description]",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filter-fieldset",
        {
          attrs: { title: _vm.t("app-organization-additional-information") },
          model: {
            value: _vm.properties.open[2],
            callback: function ($$v) {
              _vm.$set(_vm.properties.open, 2, $$v)
            },
            expression: "properties.open[2]",
          },
        },
        [
          _c("app-select", {
            attrs: {
              label: _vm.t("app-organization-type"),
              options: _vm.options.type,
              multi: "true",
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.type],
              callback: function ($$v) {
                _vm.$set(_vm.properties.delegate.filter, _vm.Fields.type, $$v)
              },
              expression: "properties.delegate.filter[Fields.type]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: {
              type: "text",
              label: _vm.t("app-organization-type-other"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.typeOther],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.typeOther,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.typeOther]",
            },
          }),
          _vm._v(" "),
          _c("app-select", {
            attrs: {
              label: _vm.t("app-organization-tax-status"),
              options: _vm.options.taxStatus,
              multi: "true",
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.taxStatus],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.taxStatus,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.taxStatus]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: {
              type: "text",
              label: _vm.t("app-organization-tax-status-other"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.taxStatusOther],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.taxStatusOther,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.taxStatusOther]",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filter-fieldset",
        {
          attrs: { title: _vm.t("app-organization-contact") },
          model: {
            value: _vm.properties.open[3],
            callback: function ($$v) {
              _vm.$set(_vm.properties.open, 3, $$v)
            },
            expression: "properties.open[3]",
          },
        },
        [
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-first-name") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.firstName],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.firstName,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.firstName]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-last-name") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.lastName],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.lastName,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.lastName]",
            },
          }),
          _vm._v(" "),
          _c("app-select", {
            attrs: {
              label: _vm.t("app-organization-tax-status-other"),
              options: _vm.options.taxStatus,
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.taxStatus],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.taxStatus,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.taxStatus]",
            },
          }),
          _vm._v(" "),
          _c("app-select", {
            attrs: {
              label: _vm.t("app-contact-position"),
              options: _vm.options.position,
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.position],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.position,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.position]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-contact-position-other") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.positionOther],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.positionOther,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.positionOther]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-contact-phone") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.phone],
              callback: function ($$v) {
                _vm.$set(_vm.properties.delegate.filter, _vm.Fields.phone, $$v)
              },
              expression: "properties.delegate.filter[Fields.phone]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: {
              type: "text",
              label: _vm.t("app-contact-alternate-phone"),
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.altPhone],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.altPhone,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.altPhone]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-email") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.email],
              callback: function ($$v) {
                _vm.$set(_vm.properties.delegate.filter, _vm.Fields.email, $$v)
              },
              expression: "properties.delegate.filter[Fields.email]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-web-address") },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.webAddress],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.webAddress,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.webAddress]",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filter-fieldset",
        {
          attrs: { title: _vm.t("app-physical-location") },
          model: {
            value: _vm.properties.open[4],
            callback: function ($$v) {
              _vm.$set(_vm.properties.open, 4, $$v)
            },
            expression: "properties.open[4]",
          },
        },
        [
          _c("app-select", {
            attrs: {
              label: _vm.t("app-organization-has-physical-location"),
              options: _vm.options.yesOrNo,
            },
            on: { input: _vm.refresh },
            model: {
              value: _vm.properties.delegate.filter[_vm.Fields.hasLocation],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.hasLocation,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.hasLocation]",
            },
          }),
          _vm._v(" "),
          _c("app-input", {
            attrs: { type: "text", label: _vm.t("app-address") },
            on: { input: _vm.refresh },
            model: {
              value:
                _vm.properties.delegate.filter[_vm.Fields.physicalLocation],
              callback: function ($$v) {
                _vm.$set(
                  _vm.properties.delegate.filter,
                  _vm.Fields.physicalLocation,
                  $$v
                )
              },
              expression: "properties.delegate.filter[Fields.physicalLocation]",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }